import { createContext } from 'react';
export var FormGroupsContext = createContext(undefined);
FormGroupsContext.displayName = 'FormGroupsContext';
//# sourceMappingURL=FormGroupsContext.js.map